import { useContext } from 'react'
import AudienceContext from '../../modules/Audience/Audience.context'
import { useMarketLanguages } from './useMarketLanguages'

/**
 * The language the audience builder should display question/option text in:
 * the explicit choice from the language switch when set, otherwise the market's
 * primary language. Audience question/option text is stored as an English
 * master plus per-locale `translations`; the display helpers overlay this
 * language and fall back to the master. `undefined` until fieldwork resolves.
 */
export const useAudienceDisplayLanguage = (): string | undefined => {
  const { audienceState } = useContext(AudienceContext)
  const { languages, primary } = useMarketLanguages()
  const selected = audienceState.displayLanguage
  // Honour the explicit choice only while it is still one of the market's
  // languages. A market's allocations can change in place (settings drawer /
  // Languages editor) without remounting the provider, which would otherwise
  // leave the builder stuck on a language the market no longer has.
  if (
    selected &&
    languages.some((l) => l.toLowerCase() === selected.toLowerCase())
  ) {
    return selected
  }
  return primary
}
